export const ARCHIVE_RETENTION_LABELS = {
  overrideId: "archive-retention-override-enabled",
  overrideLabel: "Set a custom archive retention time",
  overrideHelp: "Archives for this index set are stored for the time set here instead of the global one.",
  retentionTimeId: "archive-retention-time",
  retentionTimeLabel: "Retention Time (days)",
  retentionTimeHelp: "Define how many days to keep archives before deleting them. When 0 is set, automatic deletion is disabled.",
  globalId: "archive-retention-time-global",
  globalPlaceholder: "Could not be loaded",
  globalHelp: "Archives for this index set are stored for the global archive retention time.",
  globalUnknownHelp: "Archives for this index set are stored for the global archive retention time, which could not be loaded."
};
export const globalRetentionHelp = (globalRetentionTime) => globalRetentionTime === void 0 ? ARCHIVE_RETENTION_LABELS.globalUnknownHelp : ARCHIVE_RETENTION_LABELS.globalHelp;
